import * as React from "react"

const SvgOutbox = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 10.14v3.15q0 .424.287.712.288.287.713.287c.425 0 .52-.095.713-.287a.97.97 0 0 0 .287-.713v-3.15l.875.875a1 1 0 0 0 .338.225q.187.075.375.063.187-.013.375-.088a1 1 0 0 0 .337-.225q.275-.3.287-.7a.92.92 0 0 0-.287-.7l-2.6-2.6a.9.9 0 0 0-.325-.212A1.1 1.1 0 0 0 12 6.714q-.2 0-.375.063a.9.9 0 0 0-.325.212l-2.6 2.6a1 1 0 0 0-.3.713q0 .188.075.362.075.175.225.325.3.3.713.313a.93.93 0 0 0 .712-.288zM5 21.713q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 19.714v-14q0-.824.587-1.412A1.93 1.93 0 0 1 5 3.714h14q.824 0 1.413.588.587.587.587 1.412v14a1.93 1.93 0 0 1-.587 1.413 1.93 1.93 0 0 1-1.413.587zm0-2h14v-3h-3a5.3 5.3 0 0 1-1.787 1.475q-1.038.525-2.213.525a4.84 4.84 0 0 1-2.213-.525A5.3 5.3 0 0 1 8 16.714H5zm7-3q.8 0 1.475-.412.675-.413 1.1-1.088.15-.224.375-.362a.94.94 0 0 1 .5-.138H19v-9H5v9h3.55a.94.94 0 0 1 .5.138q.225.137.375.362.425.675 1.1 1.088.675.412 1.475.412" />
  </svg>
)
export default SvgOutbox
